import {h, Fragment} from "preact"
import { SerpElement } from "@nosto/preact"
import { useEffect, useMemo } from "preact/hooks"
import { variantFilterMatch } from "../config"

export default function Product({ product, activeFilters }) {
    const handle = useMemo(() => product.url.split("/products/")[1], [product.url]);
    
    // TODO try to simplify this, ideally this could be derived from the response directly
    const activeSku = useMemo(() => {
        if (product.skus?.length === 1 || !activeFilters || activeFilters?.length < 1) return product.skus[0];
        let match, value, fields;
        for(let i = 0; i < activeFilters.length; i++) {
            value = activeFilters[i].value.toLowerCase();
            fields = variantFilterMatch.find(filter => filter.filterField === activeFilters[i].field);

            match = product.skus.find(sku => {
                const skuValue = sku.customFields.find(f => f.key === fields.skuCustomFieldKey)?.value?.toLowerCase();
                if (skuValue){
                    return skuValue === value || skuValue.includes(value)
                } else {
                    return false
                }
            })
            if(match) {
                break;
            }
        }
        return match;
    }, [ activeFilters, product.skus ]);
    //console.log("product", handle, activeSku);
    return (
        <SerpElement
            as="li"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="ns-product w-full flex"
            product-card=""
        >
            <dynamic-product-card 
                template="product-card"
                class="w-full flex"
                handle={handle}
                variant-id={activeSku?.id}
                key={`${product.productId}-${activeSku?.id}`}
            >
                <div class='product-card-skeleton' />
            </dynamic-product-card>
    { /*
            <component--product-card
                product-id={`${product.productId}`}
                template="product-card"
                class="w-full flex"
                show-reviews="true"
                key={`${product.productId}-${activeSku?.id}`}
            >
            </component--product-card>
    */}
        </SerpElement>
    )
}